module.exports = __webpack_public_path__ + "static/media/24.3c8ed788.jpg";